'use strict';

// core
var space = require('./space');
var width = require('./width');
var fontSize = require('./font-size');
var color = require('./color');

// low-level style function creators
var style = require('./style');
var responsiveStyle = require('./responsive-style');
var pseudoStyle = require('./pseudo-style');

// extras
var textAlign = require('./text-align');
var lineHeight = require('./line-height');
var fontWeight = require('./font-weight');
var letterSpacing = require('./letter-spacing');
var alignItems = require('./align-items');
var justifyContent = require('./justify-content');
var flexWrap = require('./flex-wrap');
var flexDirection = require('./flex-direction');
var flex = require('./flex');
var alignSelf = require('./align-self');
var borderRadius = require('./border-radius');
var borderColor = require('./border-color');
var borderWidth = require('./border-width');
var boxShadow = require('./box-shadow');
var hover = require('./hover');
var focus = require('./focus');
var active = require('./active');
var disabled = require('./disabled');

// other
var theme = require('./theme');
var propTypes = require('./prop-types');
var cleanElement = require('./clean-element');
var removeProps = require('./remove-props');
var util = require('./util');
var constants = require('./constants');

module.exports = {
  space: space,
  width: width,
  fontSize: fontSize,
  color: color,
  style: style,
  responsiveStyle: responsiveStyle,
  pseudoStyle: pseudoStyle,
  textAlign: textAlign,
  lineHeight: lineHeight,
  fontWeight: fontWeight,
  letterSpacing: letterSpacing,
  alignItems: alignItems,
  justifyContent: justifyContent,
  flexWrap: flexWrap,
  flexDirection: flexDirection,
  flex: flex,
  alignSelf: alignSelf,
  borderRadius: borderRadius,
  borderColor: borderColor,
  borderWidth: borderWidth,
  boxShadow: boxShadow,
  hover: hover,
  focus: focus,
  active: active,
  disabled: disabled,
  theme: theme,
  propTypes: propTypes,
  cleanElement: cleanElement,
  removeProps: removeProps,
  util: util,
  constants: constants
};


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/styled-system/dist/index.js
// module id = 472
// module chunks = 168707334958949